import { globalConstants, candidateConstants, screenConstants } from "../../constants";

//Destructuring global constants
const { SUCCESS } = globalConstants;

//Default state of admin reducer
const initialState = {
  screenColumns: [],
  userPreferences: [],
};
//Manipulating the state of admin portal based on actions and returning the state
export const screenReducer = (state = initialState, action) => {
  switch (action.type) {
    case screenConstants.GET_COLUMNS + SUCCESS:
      return { ...state, screenColumns: action.data?.items };
    case screenConstants.GET_PREFERENCES + SUCCESS:
      return { ...state, userPreferences: action.data?.items };
    case screenConstants.CLEAR_COLUMNS + SUCCESS:
      return { ...state, screenColumns: [], userPreferences:[] };
    default:
      return state;
  }
};
